import { BaseContainerModel } from '../../base-container.model';
import { bl_dgmkt_campaign_execution_hdr_RowClass } from '../../../dbschema';

export class DgMktCampaignExecutionContainerModel extends BaseContainerModel {
  bl_dgmkt_campaign_execution_hdr: bl_dgmkt_campaign_execution_hdr_RowClass =
    new bl_dgmkt_campaign_execution_hdr_RowClass();
}
